import { connect } from 'react-redux'
import { copyFrame } from '../../actions/project/frame'
import { IconElement } from '../../components/FrameMenu/index'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  action: () => dispatch(copyFrame()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IconElement)



// WEBPACK FOOTER //
// ./src/containers/FrameMenu/Copy.js